import React from 'react';

function toDisplayValue(data) {
	if (Array.isArray(data) && data.length > 0 && data[0] && typeof data[0] === 'object') {
		const firstKey = Object.keys(data[0])[0];
		if (firstKey) {
			return data[0][firstKey];
		}
	}

	if (data && typeof data === 'object') {
		const firstKey = Object.keys(data)[0];
		if (firstKey) {
			return data[firstKey];
		}
	}

	return data;
}

function SingleValueWidget({ data }) {
	const value = toDisplayValue(data);

	return (
		<div className="flex h-full w-full items-center justify-center rounded-xl bg-slate-50 px-3 text-center">
			<p className="text-3xl font-semibold tracking-tight text-slate-800">{value == null ? '--' : String(value)}</p>
		</div>
	);
}

export default SingleValueWidget;
